export default "__VITE_ASSET__B8m3q6dS__"